export default __webpack_public_path__ + "static/media/dashboard-1.ce5b77a0.png";